const LOGIN_URL = '/oauth/token';   
const apiUrl ='http://localhost:8100/';
const tokenName = 'access-token';  
const REFRESH_TOKEN_URL = '/oauth/token';
const AUTH_CREDENTIALS = `onemoreclientid:XY7kmzoNzl100`;
const AUTH_BASIC_HEADERS = {
    headers: {
      Authorization: `Basic ${btoa(AUTH_CREDENTIALS)}`,
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  };